import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import PdfIcon from 'svg/PdfIcon';
import styles from '../ProductItems.module.css';
import {
  FLEXI_60_ACCOUNTANTS_URL,
  FLEXI_60_BROKERS_URL,
} from './productGuidesLinks';

export const LongerFlexiLoan = () => {
  const { introducerType } = useIntroducerData();
  const isAccountant = introducerType === 'accountant';

  const getPDFDownloadHref = () => {
    return isAccountant ? FLEXI_60_ACCOUNTANTS_URL : FLEXI_60_BROKERS_URL;
  };

  return (
    <div className={styles.content}>
      <h2 className={styles.title}>36, 48, 60 months</h2>
      <p className={styles.intro}>Our longest durations at our lowest rates.</p>
      <ul className={styles.benefits}>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>Borrow over</span>
          <strong>36-60 months</strong>
        </li>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>Rates from</span>
          <strong>1.50%</strong>
        </li>
        <li className={styles.benefit}>
          <span className={styles.benefitLabel}>Withdrawal fee</span>
          <strong>6%</strong>
        </li>
      </ul>
      <div className={styles.footer}>
        <PdfIcon />
        <a href={getPDFDownloadHref()} target="_blank" rel="noreferrer">
          36-60 months guide
        </a>
      </div>
    </div>
  );
};
